import { Injectable, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { NavigationEnd, Router } from '@angular/router';
import { filter, map, pairwise, startWith } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class NavigationHistoryService {
  private router = inject(Router);

  readonly previousUrl = toSignal(
    this.router.events.pipe(
      filter((e): e is NavigationEnd => e instanceof NavigationEnd),
      map(e => e.urlAfterRedirects),
      startWith(this.router.url),
      pairwise(),
      map(([prev]) => prev),
    ),
    { initialValue: this.router.url },
  );
}
